const DEFAULT_ROW_HEIGHT = 52;
const DEFAULT_HEADER_HEIGHT = 56;

export const getDataGridDynamicHeight = (
  maxHeight: number,
  rowCount: number,
  rowHeight = DEFAULT_ROW_HEIGHT,
  headerHeight = DEFAULT_HEADER_HEIGHT,
  toolbarHeight = 0,
): number => {
  if (rowCount === 0) {
    return toolbarHeight + headerHeight + rowHeight * 2;
  }

  const totalRowsHeight = rowCount * rowHeight;
  const calculatedHeight = toolbarHeight + headerHeight + totalRowsHeight;

  if (calculatedHeight < maxHeight) {
    return calculatedHeight;
  }

  return maxHeight;
};
